import { InputText } from '@/components/input-text/InputText';
import './login.css'
import { Button } from '@/components/button';

import { useNavigate } from "react-router-dom";
import { ART } from '@/constant/routes';
import { useState } from 'react';
import { useSupabaseClient } from '@/hooks/useSupabaseClient';


const supabase = useSupabaseClient();

 const Login = () => {

  const [isLoading, setIsLoading] = useState(false);
  const ERROR_MESSAGES = {
    "Invalid login credentials" : "Identifiants invalides",
    "missing email or phone" : "Identifiants manquants",
  }

  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");

  const handleSignIn = async (formData: FormData) => {
    const email = formData.get("email") as string;
    const password = formData.get("password") as string;
  
    try {

      setIsLoading(true);
      const res = await supabase.auth.signInWithPassword({
        email,
        password,
      });
   
  
      if (res.error) {
        setErrorMessage(res.error.message);
        setIsLoading(false);
        return;
      }
      navigate(ART);
    } catch (e) {
      console.log("CATCH RAW ERROR:", e);
    }

    setIsLoading(false);
  };

  return (
    <>
        <div className="login">
          
          <h1 className="login-title">Gestion de patrimoine</h1>  
          <h4 className="login-subtitle">Application de gestion de patrimoine</h4>  
          <form action={handleSignIn} className='login-form'>
            <InputText variantError={!!errorMessage} label={"Identifiant"} name={"email"} placeholder={"Adresse e-mail ou identifiant"}/>
            <InputText 
              error={errorMessage && ERROR_MESSAGES[errorMessage]} 
              label={"Mot de passe"} 
              name={"password"} 
              placeholder={"Mot de passe"}
              password={true}
              variantError={!!errorMessage}/>
            <Button isLoading={isLoading} type={"submit"} label={"Se connecter"}/>
          </form>
        </div>
        </>
  )
}

export default Login
